import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import mergeSxProp from "../../../common-utils/sx/mergeSxProp.util.js";
import Paper from "../../../components/atoms/Paper/index.js";
import { Root, Main } from "./PopupMenu.components.js";
import { headerSx, footerSx } from "./PopupMenu.sx.js";
export const PopupMenuMenuMoleculeComponent = ({ children, slots, slotProps, ...props }) => {
    const Header = slots?.header;
    const Footer = slots?.footer;
    return (_jsxs(Root, { "data-testid": "PopupMenu", component: Paper, ...props, ...slotProps?.root, children: [Header && _jsx(Header, { ...slotProps?.header, sx: mergeSxProp(headerSx, slotProps?.header?.sx) }), _jsx(Main, { ...slotProps?.main, children: children }), Footer && _jsx(Footer, { ...slotProps?.footer, sx: mergeSxProp(footerSx, slotProps?.footer?.sx) })] }));
};
export default PopupMenuMenuMoleculeComponent;
